import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useSeo } from "@/lib/seo";
import { useLang, lp } from "@/lib/i18n";

const T = {
  fr: {
    seoTitle: "Confirmation — Maison Partita",
    seoDesc: "Confirmation de ton inscription à la lettre de la maison.",
    ok: "Ton inscription est confirmée.",
    error: "Lien invalide ou expiré.",
    back: "Retour à la maison",
  },
  en: {
    seoTitle: "Confirmation — Maison Partita",
    seoDesc: "Confirmation of your subscription to the house letter.",
    ok: "Your subscription is confirmed.",
    error: "Invalid or expired link.",
    back: "Back to the house",
  },
};

export default function NewsletterConfirm() {
  const lang = useLang();
  const t = T[lang];
  useSeo(t.seoTitle, t.seoDesc);
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState("error"); return; }
    api.get(`/newsletter/confirm?token=${encodeURIComponent(token)}`)
      .then(() => setState("ok"))
      .catch(() => setState("error"));
  }, [params]);

  return (
    <section className="max-w-xl mx-auto px-5 py-40 text-center">
      {state === "loading" && <p className="text-zinc-600 tracking-[0.2em] uppercase text-[13px]">…</p>}
      {state === "ok" && (
        <p className="text-[22px] leading-relaxed text-zinc-200">{t.ok}</p>
      )}
      {state === "error" && (
        <p className="text-[18px] text-zinc-400">{t.error}</p>
      )}
      <Link to={lp(lang, "/")} className="val-link underline mt-10 inline-block">{t.back}</Link>
    </section>
  );
}
